import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import api from "@/lib/api";

/**
 * Gates a route to Pro-only entitlement (active sub / trial / bonus days /
 * legacy pro_expires_at). Calls /api/pro/me on mount. Non-Pro users are
 * redirected to /pro with `?gate={feature}` so the upgrade page can show a
 * "You came from {feature} — that's a Pro perk" banner.
 *
 * While the entitlement check is in flight, renders a neutral spinner so
 * the page doesn't flash content the user is about to be redirected away
 * from.
 */
export default function ProRoute({ children, feature = "leaderboard" }) {
  const location = useLocation();
  const [state, setState] = useState({ loading: true, isPro: false });

  useEffect(() => {
    let alive = true;
    api.get("/pro/me")
      .then((r) => { if (alive) setState({ loading: false, isPro: !!r.data?.is_pro }); })
      .catch(() => { if (alive) setState({ loading: false, isPro: false }); });
    return () => { alive = false; };
  }, [location.pathname]);

  if (state.loading) {
    return (
      <div
        data-testid="pro-route-loading"
        className="min-h-screen flex items-center justify-center bg-[#0A0A0A] text-zinc-500 text-xs uppercase tracking-widest"
      >
        …
      </div>
    );
  }

  if (!state.isPro) {
    return <Navigate to={`/pro?gate=${encodeURIComponent(feature)}`} replace />;
  }
  return children;
}
